import {
  contrast,
  hexToDecimal,
  isColorLight,
  isValidHexColor,
} from 'utils/colors';
import COLORS from 'constants/colors';
import { ON_COLOR_SETTINGS } from 'constants/settings';

export const COLOR_ERRORS = {
  INVALID_COLOR: 'invalid-color',
  LOW_CONTRAST: 'low-contrast',
};

export const validateColor = (color, validateContrast = false) => {
  if (!isValidHexColor(color)) {
    return COLOR_ERRORS.INVALID_COLOR;
  }

  const customLinkColorConstrast = contrast(
    hexToDecimal('ffffff'),
    hexToDecimal(color.substr(1)),
  );
  if (validateContrast && customLinkColorConstrast < 3) {
    return COLOR_ERRORS.LOW_CONTRAST;
  }

  return null;
};

export const getColorFromSetting = (setting, color) => {
  if (setting === ON_COLOR_SETTINGS.DARK) {
    return COLORS.MIDNIGHT_100;
  }

  if (setting === ON_COLOR_SETTINGS.LIGHT) {
    return COLORS.WHITE;
  }

  return isColorLight(color.substr(1)) ? COLORS.MIDNIGHT_100 : COLORS.WHITE;
};

export const isColorValid = (color, validateContrast) =>
  !validateColor(color, validateContrast);

export const isDarkAppearance = (setting, color) =>
  setting === ON_COLOR_SETTINGS.DARK ||
  (setting === ON_COLOR_SETTINGS.AUTO && isColorLight(color.substr(1)));

export const isLightAppearance = (setting, color) =>
  setting === ON_COLOR_SETTINGS.LIGHT ||
  (setting === ON_COLOR_SETTINGS.AUTO && !isColorLight(color.substr(1)));
